package com.havn.app.features.notifications.data

actual fun currentDeviceTimezone(): String = js("Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC'") as String
